// 正式
module.exports = {
  title: '共创家—共创家web端',
  baseUrl: 'https://platform.gongchuangjia.com/', // 正式项目地址
  baseApi: 'https://applet.yangshizhengya.com/applet/', // 正式api请求地址
  $cdn: 'https://hyjy-oss.oss-cn-chengdu.aliyuncs.com/mp/assets/'
};
